const adminOnly = (to, from, next) => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}')
  const roles = [
    ...(Array.isArray(userData.roles) ? userData.roles : []),
    ...(Array.isArray(userData.role) ? userData.role : []),
    ...(typeof userData.role === 'string' ? [userData.role] : []),
  ].map(role => String(role).toLowerCase())

  if (roles.includes('admin')) {
    next()
    return
  }

  next({ name: 'misc-not-authorized' })
}

export default [
  {
    path: '/offerwall',
    name: 'dashboard-google-ads',
    component: () => import('@/views/dashboard/google-ads/List.vue'),
    meta: {
      resource: 'Google Ads',
      action: 'manage',
    },
  },
  {
    path: '/users/:userId/offerwall',
    name: 'dashboard-user-google-ads',
    component: () => import('@/views/dashboard/google-ads/AccountAds.vue'),
  },
  {
    path: '/users/:userId/offerwall/create',
    name: 'dashboard-google-ads-create',
    component: () => import('@/views/dashboard/google-ads/New.vue'),
  },
  {
    path: '/users/:userId/offerwall/:adId/edit',
    name: 'dashboard-google-ads-edit',
    component: () => import('@/views/dashboard/google-ads/Edit.vue'),
  },
  {
    path: '/users/:userId/offerwall/:adId/stats',
    name: 'dashboard-google-ads-stats',
    component: () => import('@/views/dashboard/google-ads/Stats.vue'),
  },
  {
    path: '/users/:userId/offerwall/:adId/events',
    name: 'dashboard-google-ads-events',
    component: () => import('@/views/dashboard/google-ads/Events.vue'),
    meta: {
      resource: 'OfferWall Events',
      action: 'manage',
    },
    beforeEnter: adminOnly,
  },
]
